import axios from '@/util/request'
const baseURL = process.env.VUE_APP_API_URL

export default {
  discountDetailProduct: data => axios({ baseURL, url: '/api/product/open/discount/getDiscountProductList', method: 'post', data }), // (前台)获取折扣活动产品列表
  getDiscountListForTabs: data => axios({ baseURL, url: '/api/product/open/discount/getDiscountList', method: 'post', data }), // 获取促销活动列表

  getDiscountBanner: params => axios({ baseURL, url: `/api/product/open/discount/banner`, method: 'get', params }), // 获取活动banner图
  getDiscountConfig: params => axios({ baseURL, url: `/api/product/open/discount/config`, method: 'get', params }) // 获取促销活动配置

}
